import React from "react"

const Loading = props => {
    const {
        processing,
    } = props
    return (
        <div className={`loading ${processing ? '' : 'hidden'}`}>
            <img src="https://stgokulabweb.blob.core.windows.net/images/contact/loading.svg" alt="Loading..."/>
        </div>
    )
}

export default Loading